export const CLOUDINARY_CDN =
  "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";
export const STAR = "https://www.svgrepo.com/show/3121/rating.svg";
export const LOGO =
  "https://img.freepik.com/free-vector/delivery-service-illustrated_23-2148505081.jpg?w=740&t=st=1695823021~exp=1695823621~hmac=c5222cd84a9699d26d7d27ab0c6e3fd6eaa096882a2211d6639cdfea3606b011";

export const RES_API =
  "https://corsproxy.org/?https%3A%2F%2Fwww.swiggy.com%2Fdapi%2Frestaurants%2Flist%2Fv5%3Flat%3D23.022505%26lng%3D72.5713621%26page_type%3DDESKTOP_WEB_LISTING";

export const MENU_API =
  "https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=12.9351929&lng=77.62448069999999&restaurantId=";

export const MENU_CARD_IMGID =
  "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_1024/";

export const NON_VEG =
  "https://uxwing.com/wp-content/themes/uxwing/download/food-and-drinks/non-veg-icon.png";
export const VEG =
  "https://uxwing.com/wp-content/themes/uxwing/download/food-and-drinks/veg-icon.png";

export const DUMMY_IMG =
  "https://images.pexels.com/photos/1247677/pexels-photo-1247677.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2";
